import { Button, Form, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { loadAllDesignation } from "../../../redux/rtk/features/designation/designationSlice";
import { loadAllEmploymentStatus } from "../../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import { loadAllLeavePolicy } from "../../../redux/rtk/features/leavePolicy/leavePolicySlice";
import { loadAllShift } from "../../../redux/rtk/features/shift/shiftSlice";
import { getCompanyNameByClientId, loadAllStaff, loadSingleStaff, updateUser } from "../../../redux/rtk/features/user/userSlice";
import { loadAllWeeklyHoliday } from "../../../redux/rtk/features/weeklyHoliday/weeklyHolidaySlice";
import getCompanyIdFromToken from "../../../utils/getCompanyIdFromToken";
import { getDepartments } from "../../department/departmentApis";
import { getRoles } from "../../role/roleApis";
import BtnEditSvg from "../Button/btnEditSvg";
import getPermissions from "../../../utils/getPermissions";

const EmployeeEditPopup = ({ userId, user }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { id } = useParams();
    const permissions = getPermissions();
	const hasPermission = (item) => {
		return permissions?.includes(item ? item : "");
	};

    // Selectors
    const users = useSelector((state) => state.users?.list);
    const officeName = useSelector((state) => state.users?.companyName);

    const weeklyHoliday = useSelector((state) => state.weeklyHoliday?.list);
    const employmentStatus = useSelector((state) => state.employmentStatus?.list);
    const shift = useSelector((state) => state.shift?.list);
    const departmentList = useSelector((state) => state.department?.list);
    const designation = useSelector((state) => state.designations?.list);

    const [rolesList, setRolesList] = useState(null);
    const [departmentsList, setDepartmentsList] = useState(null);

    // Load initial data
    useEffect(() => {
        dispatch(loadAllDesignation());
        dispatch(loadAllEmploymentStatus());
        dispatch(loadAllShift());
        dispatch(loadAllWeeklyHoliday());
        dispatch(loadAllLeavePolicy());
        dispatch(loadAllStaff({ status: true }));
    }, [dispatch]);

    // Load roles
    useEffect(() => {
        getRoles()
            .then((data) => setRolesList(data))
            .catch((error) => console.log("Error loading roles:", error));
    }, []);

    // Load departments
    useEffect(() => {
        getDepartments()
            .then((data) => setDepartmentsList(data))
            .catch((error) => console.log("Error loading departments:", error));
    }, []);

    // Prefill form data when modal opens
    useEffect(() => {
        if (isModalOpen && user) {
            console.log('Setting form values with user data:', user);
            form.resetFields();
            form.setFieldsValue({
                employeeId: user?.employeeId || "",
                officialMailId: user?.officialMailId || "",
                esic: user?.esic || "",
                uan: user?.uan || "",
                employmentStatusId: user?.employmentStatusId || "",
                departmentId: user?.departmentId || "",
                reportingManagerId: user?.reportingManagerId || "",
                roleId: user?.roleId || "",
                shiftId: user?.shiftId || "",
                weeklyHolidayId: user?.weeklyHolidayId || "",
                pfEligiblity: user?.pfEligiblity === true ? "Eligible" : "NotEligible",
                CompanyOfficeId: user?.CompanyOfficeId ||"",
                // paymentType: user?.paymentType || "",
                paymentType: user?.tbl_paymentType?.[0]?.paymentType || "",
            });
        }
    }, [isModalOpen, user, form]);

    const companyId = getCompanyIdFromToken();
    console.log("companyId", companyId);
    // Dispatch action to fetch company names
    useEffect(() => {
        dispatch(getCompanyNameByClientId(companyId));
    }, [dispatch]);

    // Debug logging for user data
    useEffect(() => {
        if (user) {
            console.log('Current user data:', user);
        }
    }, [user]);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const onFinish = async (values) => {
        const updatedValues = {
            ...values,
            //   pfEligiblity: values.pfEligiblity === "Eligible"
            pfEligiblity: values.pfEligiblity === "Eligible" ? true : false
        };

        try {
            const response = await dispatch(updateUser({ id: userId, values: updatedValues }));
            if (response.payload.message === "success") {
                dispatch(loadSingleStaff(id));
                setIsModalOpen(false);
                form.resetFields();
            }
        } catch (error) {
            console.error("Error updating employee details:", error);
        }
    };

    return (
        <>
            <button onClick={showModal}>
                <BtnEditSvg size={30} />
            </button>
            <Modal
                title="Update Employee Details"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    name="employeeDetails"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        label="Employee ID"
                        name="employeeId"
                        rules={[{ required: true, message: "Please enter the employee ID!" }]}
                    >
                        <Input placeholder="Enter employee ID" />
                    </Form.Item>

                    <Form.Item
                        label="Official Email ID"
                        name="officialMailId"
                        rules={[{ required: true, message: "Please enter the official email!" }]}
                    >
                        <Input placeholder="Enter official email" />
                    </Form.Item>

                    <Form.Item
                        label="ESIC"
                        name="esic"
                    >
                        <Input placeholder="Enter ESIC number" />
                    </Form.Item>

                    <Form.Item
                        label="UAN"
                        name="uan"
                    >
                        <Input placeholder="Enter UAN number" />
                    </Form.Item>

                    <Form.Item
                        name="employmentStatusId"
                        label="Employment Status"
                        rules={[{ required: true, message: "Please select employment status!" }]}
                    >
                        <Select
                            placeholder="Select Status"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {employmentStatus?.map((status) => (
                                <Select.Option key={status.id} value={status.id}>
                                    {status.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="departmentId"
                        label="Department"
                        rules={[{ required: true, message: "Please select department!" }]}
                    >
                        <Select
                            loading={!departmentsList}
                            placeholder="Select Department"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {departmentsList?.map((department) => (
                                <Select.Option key={department.id} value={department.id}>
                                    {department.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Reporting Manager"
                        name="reportingManagerId"
                        rules={[{ required: true, message: "Please select a reporting manager!" }]}
                    >
                        <Select
                            placeholder="Select reporting manager"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {users?.map((user) => (
                                <Select.Option key={user.id} value={user.id}>
                                    {`${user.firstName} ${user.lastName}`}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="roleId"
                        label="Role"
                        rules={[
                            { required: hasPermission('update-role'), message: "Please select user role!" }
                        ]}
                    >
                        <Select
                            loading={!rolesList}
                            placeholder={hasPermission('update-role') ? "Select Role" : "You don't have permission to update"}
                            showSearch
                            allowClear
                            disabled={!hasPermission('update-role')} // Disable the field if no permission
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {rolesList?.map((role) => (
                                <Select.Option key={role.id} value={role.id}>
                                    {role.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="CompanyOfficeId"
                        style={{ marginBottom: "10px" }}
                        label="Office"
                        rules={[
                            { required: true, message: "Please Select Office!" },
                        ]}

                    >
                        <Select
                            loading={!officeName}
                            placeholder="Select Office"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                            size="middle"
                        >
                            {officeName &&
                                officeName.map((office) => (
                                    <Select.Option key={office.id} value={office.id}>
                                        {office.company_name}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Shift"
                        name="shiftId"
                    >
                        <Select
                            placeholder="Select shift"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {shift?.map((shiftItem) => (
                                <Select.Option key={shiftItem.id} value={shiftItem.id}>
                                    {shiftItem.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Weekly Holiday"
                        name="weeklyHolidayId"
                    >
                        <Select
                            placeholder="Select weekly holiday"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {weeklyHoliday?.map((holiday) => (
                                <Select.Option key={holiday.id} value={holiday.id}>
                                    {holiday.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="PF Eligibility"
                        name="pfEligiblity"
                        rules={[{ required: true, message: "Please select PF eligibility!" }]}
                    >
                        <Select placeholder="Select PF Eligibility">
                            <Select.Option value="Eligible">Eligible</Select.Option>
                            <Select.Option value="NotEligible">Not Eligible</Select.Option>
                        </Select>
                    </Form.Item>


                    <Form.Item
                        label="Payment Type"
                        name="paymentType"
                    >
                        <Select placeholder="Select payment type">
                            <Select.Option value="Cheque">Cheque</Select.Option>
                            <Select.Option value="Cash">Cash</Select.Option>
                            <Select.Option value="Bank Transfer">Bank Transfer</Select.Option>
                            <Select.Option value="others">Others</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default EmployeeEditPopup;